import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section with Image */}
      <section className="relative w-full h-[70vh] overflow-hidden mt-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1920&q=80)',
            filter: 'grayscale(100%)'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-[900px] mx-auto px-8 py-20">
        
        {/* Intro Heading */}
        <h1 className="text-5xl md:text-6xl font-bold text-black mb-16 lowercase">
          more about us
        </h1>

        {/* Mission Section */}
        <section className="mb-16">
          <h2 className="text-sm uppercase tracking-widest font-bold text-black mb-6">
            MISSION
          </h2>
          <p className="text-lg leading-relaxed text-gray-800">
            To turn japanese creativity into global, sustainable businesses and to turn global brands to localize in Japan. we do this by putting <strong>FANDOM FIRST</strong>, building the right structures, and executing across borders without losing speed, control, or cultural integrity.
          </p>
        </section>

        {/* Who We Are Section */}
        <section className="mb-16">
          <h2 className="text-sm uppercase tracking-widest font-bold text-black mb-6">
            WHO WE ARE
          </h2>
          <div className="space-y-6 text-lg leading-relaxed text-gray-800">
            <p>
              we are not a traditional creative agency.
            </p>
            <p>
              we are a producer house and IP strategy studio, designed to work hands-on with artists, rights holders, platforms, and brands. we translate between japan and the global market — creatively, commercially, and operationally.
            </p>
            <p>
              <strong>going plus</strong> represents a shift away from export-by-accident. instead of chasing trends or short-term exposure, we focus on long-term fandom, ownership, and repeatable growth. every project is designed to travel, compound, and last.
            </p>
          </div>
        </section>

        {/* CEO Section */}
        <section className="mb-16">
          <h2 className="text-sm uppercase tracking-widest font-bold text-black mb-6">
            CEO
          </h2>
          <p className="text-lg leading-relaxed text-gray-800 mb-12">
            <strong>going plus</strong> was founded by <strong>taiga kunii</strong>, a tokyo-based producer and operator working at the intersection of music, entertainment, and intellectual property. after years of operating inside japan's industry and alongside global partners, going plus was built to solve a simple problem: world-class japanese IP exists — but the systems to scale it globally are broken.
          </p>
          
          {/* CEO Profile Photo */}
          <div className="flex justify-center mt-12">
            <img 
              src="https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/l7gl0757_Profile%20photo%202.jpg"
              alt="Taiga Kunii, CEO of going plus"
              className="w-80 h-80 object-cover rounded-sm shadow-lg"
            />
          </div>
          <p className="text-center text-sm text-gray-600 mt-4">
            Taiga Kunii, CEO & Founder
          </p>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;